// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gray {
  color: #292727;
}

@media (min-width: 768px) {
  .react-modal-overlay.manage-subscription-modal .react-modal,
  .react-modal-overlay.upgrade-to-lifetime-modal .react-modal,
  .swap-to-web .react-modal {
    padding-top: 1rem;
    top: 15%;
    left: calc(50% - 16rem);
    width: 32rem;
    height: 35rem;
    height: -moz-fit-content;
    height: fit-content;
    max-height: 85%;
    box-shadow: 0.3rem 0.5rem 0.5rem 0 rgba(0, 0, 0, 0.19);
    border-radius: 0.5rem;
    overflow-x: hidden;
  }
}
.react-modal-overlay.manage-subscription-modal .logo-wrapper,
.react-modal-overlay.upgrade-to-lifetime-modal .logo-wrapper,
.swap-to-web .logo-wrapper {
  text-align: center;
}
.react-modal-overlay.manage-subscription-modal .logo-wrapper img.logo,
.react-modal-overlay.upgrade-to-lifetime-modal .logo-wrapper img.logo,
.swap-to-web .logo-wrapper img.logo {
  height: 5rem;
  margin-bottom: 2rem;
  margin-top: 2rem;
}
@media (min-width: 768px) {
  .react-modal-overlay.manage-subscription-modal .logo-wrapper,
  .react-modal-overlay.upgrade-to-lifetime-modal .logo-wrapper,
  .swap-to-web .logo-wrapper {
    display: none;
  }
}
.react-modal-overlay.manage-subscription-modal h1,
.react-modal-overlay.upgrade-to-lifetime-modal h1,
.swap-to-web h1 {
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 1rem;
}
.react-modal-overlay.manage-subscription-modal .actions,
.react-modal-overlay.upgrade-to-lifetime-modal .actions,
.swap-to-web .actions {
  display: flex;
  justify-content: space-around;
  margin-top: 2rem;
}
.react-modal-overlay.manage-subscription-modal .actions .btn.pill,
.react-modal-overlay.upgrade-to-lifetime-modal .actions .btn.pill,
.swap-to-web .actions .btn.pill {
  padding: 1rem 1.8rem;
  line-height: 1.2;
  font-weight: 600;
  font-size: 1.5rem;
}
.react-modal-overlay.manage-subscription-modal h1,
.react-modal-overlay.upgrade-to-lifetime-modal h1,
.swap-to-web h1 {
  font-size: 1.8rem;
  font-style: italic;
  font-family: "Libre Baskerville";
  font-weight: 100;
  text-align: center;
  color: #333;
  margin: 2.4rem 1rem;
}
.react-modal-overlay.manage-subscription-modal .plan,
.react-modal-overlay.upgrade-to-lifetime-modal .plan,
.swap-to-web .plan {
  border: 2px solid #b3b3b3;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 0.8rem;
}
.react-modal-overlay.manage-subscription-modal .plan h2,
.react-modal-overlay.upgrade-to-lifetime-modal .plan h2,
.swap-to-web .plan h2 {
  text-transform: uppercase;
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
  margin: 0 0 0.8rem;
  text-align: center;
}
.react-modal-overlay.manage-subscription-modal .plan__billing,
.react-modal-overlay.upgrade-to-lifetime-modal .plan__billing,
.swap-to-web .plan__billing {
  border: 1px solid #b3b3b3;
  padding: 0.6rem 0.9rem;
  color: #919191;
  text-transform: uppercase;
  font-size: 1.8rem;
  font-weight: 600;
  line-height: 1;
}
.react-modal-overlay.manage-subscription-modal .plan__subtext,
.react-modal-overlay.upgrade-to-lifetime-modal .plan__subtext,
.swap-to-web .plan__subtext {
  font-size: 1.2rem;
  font-weight: 300;
  color: #919191;
  line-height: 1;
  margin: 0.8rem 0 0;
}
.react-modal-overlay.manage-subscription-modal .plan__benefits,
.react-modal-overlay.upgrade-to-lifetime-modal .plan__benefits,
.swap-to-web .plan__benefits {
  font-size: 1.4rem;
  font-weight: 400;
  color: #333;
  text-align: center;
  line-height: 1.2;
}
.react-modal-overlay.manage-subscription-modal .plan--selected,
.react-modal-overlay.upgrade-to-lifetime-modal .plan--selected,
.swap-to-web .plan--selected {
  border-color: #dabc64;
  padding: 1.6rem 1rem;
}
.react-modal-overlay.manage-subscription-modal .plan--selected .plan__billing,
.react-modal-overlay.upgrade-to-lifetime-modal .plan--selected .plan__billing,
.swap-to-web .plan--selected .plan__billing {
  color: white;
  background-color: #dabc64;
  border-color: #dabc64;
}
.react-modal-overlay.manage-subscription-modal .notes,
.react-modal-overlay.upgrade-to-lifetime-modal .notes,
.swap-to-web .notes {
  font-size: 1.4rem;
  color: #333;
  text-align: center;
}
.react-modal-overlay.manage-subscription-modal .error-message,
.react-modal-overlay.upgrade-to-lifetime-modal .error-message,
.swap-to-web .error-message {
  color: red;
  text-align: center;
}
.react-modal-overlay.manage-subscription-modal .payment-method,
.react-modal-overlay.upgrade-to-lifetime-modal .payment-method,
.swap-to-web .payment-method {
  display: flex;
  justify-content: space-between;
  border: 1px solid #ccc;
  border-radius: 0.5rem;
  padding: 0.5rem;
  margin: 0.5rem 0;
}
.react-modal-overlay.manage-subscription-modal .payment-method--centered,
.react-modal-overlay.upgrade-to-lifetime-modal .payment-method--centered,
.swap-to-web .payment-method--centered {
  justify-content: center;
}
.react-modal-overlay.manage-subscription-modal h2,
.react-modal-overlay.upgrade-to-lifetime-modal h2,
.swap-to-web h2 {
  margin-top: 2rem;
  font-size: 1.4rem;
}
.react-modal-overlay.manage-subscription-modal .swap-to-paddle .spinner-wrapper,
.react-modal-overlay.upgrade-to-lifetime-modal .swap-to-paddle .spinner-wrapper,
.swap-to-web .swap-to-paddle .spinner-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 1000;
}
.react-modal-overlay.manage-subscription-modal .current-card-info,
.react-modal-overlay.upgrade-to-lifetime-modal .current-card-info,
.swap-to-web .current-card-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

@media (min-width: 768px) {
  .react-modal-overlay.upgrade-to-lifetime-modal .react-modal {
    width: 47.5rem;
    left: calc(50% - 23.75rem);
  }
}
.react-modal-overlay.upgrade-to-lifetime-modal .react-modal .payment-intent-form .StripeElement {
  width: 100%;
}
.react-modal-overlay.upgrade-to-lifetime-modal .react-modal h1 {
  margin-bottom: 0.5rem;
}
.react-modal-overlay.upgrade-to-lifetime-modal .react-modal p.sub-header {
  font-weight: 100;
  font-style: italic;
  font-family: "Libre Baskerville";
  text-align: center;
  margin-bottom: 1rem;
}
.react-modal-overlay.upgrade-to-lifetime-modal .react-modal p {
  margin-bottom: 1rem;
  text-align: center;
}
.react-modal-overlay.upgrade-to-lifetime-modal .react-modal .checkout-wrapper {
  position: relative;
}
.react-modal-overlay.upgrade-to-lifetime-modal .react-modal .spinner-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.05);
  z-index: 1000;
}`, "",{"version":3,"sources":["webpack://./src/Styles/Colors.scss","webpack://./src/Components/ManageSubscription/ManageSubscription.scss"],"names":[],"mappings":"AAsCA;EACE,cArCU;ACAZ;;AAKI;EADF;;;IAEI,iBAAA;IACA,QAAA;IACA,uBAAA;IACA,YAAA;IACA,aAAA;IACA,wBAAA;IAAA,mBAAA;IACA,eAAA;IAGA,sDAAA;IACA,qBAAA;IACA,kBAAA;EACJ;AACF;AAEE;;;EACE,kBAAA;AAEJ;AADI;;;EACE,YAAA;EACA,mBAAA;EACA,gBAAA;AAKN;AAFI;EARF;;;IASI,aAAA;EAOJ;AACF;AAJE;;;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AAQJ;AALE;;;EACE,aAAA;EACA,6BAAA;EACA,gBAAA;AASJ;AARI;;;EACE,oBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AAYN;AARE;;;EACE,iBAAA;EACA,kBAAA;EACA,gCAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;AAYJ;AATE;;;EACE,yBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,qBAAA;AAaJ;AAXI;;;EACE,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;AAeN;AAZI;;;EACE,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AAgBN;AAbI;;;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;AAiBN;AAdI;;;EACE,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AAkBN;AAfI;;;EACE,qBD1FC;EC2FD,oBAAA;AAmBN;AAjBM;;;EACE,YAAA;EACA,yBD/FD;ECgGC,qBDhGD;ACqHP;AAhBE;;;EACE,iBAAA;EACA,WAAA;EACA,kBAAA;AAoBJ;AAjBE;;;EACE,UAAA;EACA,kBAAA;AAqBJ;AAlBE;;;EACE,aAAA;EACA,8BAAA;EACA,sBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;AAsBJ;AApBI;;;EACE,uBAAA;AAwBN;AApBE;;;EACE,gBAAA;EACA,iBAAA;AAwBJ;AApBI;;;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,oCAAA;EACA,aAAA;AAwBN;AApBE;;;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAwBJ;;AAlBI;EADF;IAEI,cAAA;IACA,0BAAA;EAsBJ;AACF;AAnBM;EACE,WAAA;AAqBR;AAjBI;EACE,qBAAA;AAmBN;AAhBI;EACE,gBAAA;EACA,kBAAA;EACA,gCAAA;EACA,kBAAA;EACA,mBAAA;AAkBN;AAfI;EACE,mBAAA;EACA,kBAAA;AAiBN;AAdI;EACE,kBAAA;AAgBN;AAbI;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,qCAAA;EACA,aAAA;AAeN","sourcesContent":["// Define colors here to use across the site\n\n$textColor: #292727;\n$darkTextColor: #696969;\n$lightTextColor: #cacacb;\n$black: black;\n$borderColor: #c0c0c0;\n$gridBorderColor: #ddd;\n$hoverColor: #b8b8b8;\n$shadow: #9c9c9c;\n$gray: #efefef;\n$darkGray: #515554;\n$backgroundColor: #ffffff;\n$backgroundRight: #ffffff;\n$backgroundLeft: #e9e9e9;\n$success: #18b100;\n$headingsGray: #333333;\n$camelGold: #d0ad4d;\n$gold: #dabc64;\n$iconColor: #9c9c9c;\n$navIcon: #4d4d4d;\n$navIconActive: #dabc64;\n$iconColorActive: #dabc64;\n$magenta: #ab3a72;\n$habitPrimary: rgb(51, 51, 51);\n$habitBorder: rgb(208, 213, 221);\n$habitActionText: rgb(86, 86, 86);\n$habitActionIcon: #565656;\n\n// Brands\n$brand-primary: #3097d1;\n$brand-info: #8eb4cb;\n$brand-success: #2ab27b;\n$brand-warning: #cbb956;\n$brand-danger: red;\n\n$orange: #f5a000;\n\n.gray {\n  color: $textColor;\n}\n\n$input-color: #555;\n\n$headingColor: #999;\n$dayHeadingColor: #555;\n$undoBackground: #bdbdbd;\n","@import 'Colors.scss';\n@import 'Variables.scss';\n\n.react-modal-overlay.manage-subscription-modal,\n.react-modal-overlay.upgrade-to-lifetime-modal,\n.swap-to-web {\n  .react-modal {\n    @media (min-width: $tablet) {\n      padding-top: 1rem;\n      top: 15%;\n      left: calc(50% - 16rem);\n      width: 32rem;\n      height: 35rem;\n      height: fit-content;\n      max-height: 85%;\n      -webkit-box-shadow: 0.3rem 0.5rem 0.5rem 0 rgba(0, 0, 0, 0.19);\n      -moz-box-shadow: 0.3rem 0.5rem 0.5rem 0 rgba(0, 0, 0, 0.19);\n      box-shadow: 0.3rem 0.5rem 0.5rem 0 rgba(0, 0, 0, 0.19);\n      border-radius: 0.5rem;\n      overflow-x: hidden;\n    }\n  }\n\n  .logo-wrapper {\n    text-align: center;\n    img.logo {\n      height: 5rem;\n      margin-bottom: 2rem;\n      margin-top: 2rem;\n    }\n\n    @media (min-width: $tablet) {\n      display: none;\n    }\n  }\n\n  h1 {\n    font-size: 2rem;\n    font-weight: 600;\n    margin-bottom: 1rem;\n  }\n\n  .actions {\n    display: flex;\n    justify-content: space-around;\n    margin-top: 2rem;\n    .btn.pill {\n      padding: 1rem 1.8rem;\n      line-height: 1.2;\n      font-weight: 600;\n      font-size: 1.5rem;\n    }\n  }\n\n  h1 {\n    font-size: 1.8rem;\n    font-style: italic;\n    font-family: 'Libre Baskerville';\n    font-weight: 100;\n    text-align: center;\n    color: #333;\n    margin: 2.4rem 1rem;\n  }\n\n  .plan {\n    border: 2px solid #b3b3b3;\n    padding: 1rem;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-bottom: 0.8rem;\n\n    h2 {\n      text-transform: uppercase;\n      font-size: 1.5rem;\n      font-weight: 600;\n      color: #333;\n      margin: 0 0 0.8rem;\n      text-align: center;\n    }\n\n    &__billing {\n      border: 1px solid #b3b3b3;\n      padding: 0.6rem 0.9rem;\n      color: #919191;\n      text-transform: uppercase;\n      font-size: 1.8rem;\n      font-weight: 600;\n      line-height: 1;\n    }\n\n    &__subtext {\n      font-size: 1.2rem;\n      font-weight: 300;\n      color: #919191;\n      line-height: 1;\n      margin: 0.8rem 0 0;\n    }\n\n    &__benefits {\n      font-size: 1.4rem;\n      font-weight: 400;\n      color: #333;\n      text-align: center;\n      line-height: 1.2;\n    }\n\n    &--selected {\n      border-color: $gold;\n      padding: 1.6rem 1rem;\n\n      .plan__billing {\n        color: white;\n        background-color: $gold;\n        border-color: $gold;\n      }\n    }\n  }\n\n  .notes {\n    font-size: 1.4rem;\n    color: #333;\n    text-align: center;\n  }\n\n  .error-message {\n    color: red;\n    text-align: center;\n  }\n\n  .payment-method {\n    display: flex;\n    justify-content: space-between;\n    border: 1px solid #ccc;\n    border-radius: 0.5rem;\n    padding: 0.5rem;\n    margin: 0.5rem 0;\n\n    &--centered {\n      justify-content: center;\n    }\n  }\n\n  h2 {\n    margin-top: 2rem;\n    font-size: 1.4rem;\n  }\n\n  .swap-to-paddle {\n    .spinner-wrapper {\n      position: absolute;\n      top: 0;\n      left: 0;\n      bottom: 0;\n      right: 0;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      background-color: rgba(0, 0, 0, 0.2);\n      z-index: 1000;\n    }\n  }\n\n  .current-card-info {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n}\n\n.react-modal-overlay.upgrade-to-lifetime-modal {\n  .react-modal {\n    @media (min-width: $tablet) {\n      width: 47.5rem;\n      left: calc(50% - 23.75rem);\n    }\n\n    .payment-intent-form {\n      .StripeElement {\n        width: 100%;\n      }\n    }\n\n    h1 {\n      margin-bottom: 0.5rem;\n    }\n\n    p.sub-header {\n      font-weight: 100;\n      font-style: italic;\n      font-family: 'Libre Baskerville';\n      text-align: center;\n      margin-bottom: 1rem;\n    }\n\n    p {\n      margin-bottom: 1rem;\n      text-align: center;\n    }\n\n    .checkout-wrapper {\n      position: relative;\n    }\n\n    .spinner-wrapper {\n      position: absolute;\n      top: 0;\n      left: 0;\n      bottom: 0;\n      right: 0;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      background-color: rgba(0, 0, 0, 0.05);\n      z-index: 1000;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
